import { NrqlResponse, NrqlResult, ApiPerformanceData } from "./types"

const NEW_RELIC_API_URL = "https://mw-os.dev.tap.company/api/api-performance"

/**
 * Fetches API performance data from New Relic
 */
export const fetchApiPerformanceData = async (duration: string = "1 day ago"): Promise<ApiPerformanceData[]> => {
  try {
    const url = new URL(NEW_RELIC_API_URL)
    url.searchParams.append("duration", duration)

    const response = await fetch(url.toString(), {
      method: "GET",
      headers: {
        "Content-Type": "application/json"
      }
    })

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    const data: NrqlResponse = await response.json()

    // Transform the data to a more usable format
    return transformNrqlResults(data.data.actor.account.nrql.results)
  } catch (error) {
    console.error("Error fetching API performance data:", error)
    throw error
  }
}

/**
 * Transforms NRQL results to ApiPerformanceData format
 */
const transformNrqlResults = (results: NrqlResult[]): ApiPerformanceData[] => {
  return results.map((result) => ({
    product: result.facet[0],
    service: result.facet[1],
    region: result.facet[2],
    uptime: result["API Uptime %"],
    avgDbResponseTime: result["Avarage DB Response Time"],
    avgResponseTime: result["Avg Response Time (sec)"],
    errorRate: result["Error Rate %"]
  }))
}
